import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

export const EmptyState = ({ name }: { name?: string }) => (
  <div className="flex h-full flex-col items-center justify-center gap-2">
    <Icon name="magnifying-glass" size="md" />
    <div className="w-48 text-center">
      <Typography variant="body-sm">
        {t("chat_space.search_messages.empty_state")}
      </Typography>
      <Typography variant="body-sm">{name || ""}</Typography>
    </div>
  </div>
);
